<div class="dropdown-menu dropdown-menu-right width-180" [class.show]="userMenuActive">
    <div class="dropdown-item btn-wrap"
         *ngIf="!!USER.daysRemainingInTrial">
        <a class="btn btn-block btn-success" [href]="'/entitlements/unpaid_trial_wall'">
            Subscribe Now
        </a>
    </div>

    @if (USER.impersonationState.showImpersonationMenu){
        <ycn-impersonation-menu
            [userMenuActive]="userMenuActive"
            (addErrorMessageHandler)="addErrorMessageHandler.emit($event)"
        ></ycn-impersonation-menu>
        <div class="dropdown-divider"></div>
    }
    @for (option of menuOptions; track option) {
        @if (option.title === 'Sign Out') {
            <form *ngIf="USER.authenticated" [action]="option.href" method="post" ngNoForm>
                <input type="hidden" name="csrfmiddlewaretoken" [value]="csrfToken" autocomplete="off">
                <button type="submit" class="dropdown-item" [attr.data-test-id]="option.dataTestId">
                    <div class="dropdown-item-text">Sign Out</div>
                </button>
            </form>
        } @else {
                <a class="dropdown-item" [href]="option.href" [attr.data-test-id]="option.dataTestId">
                    <div class="dropdown-item-text" [textContent]="option.title"></div>
                </a>
        }
    }
</div>
